module.exports = __webpack_public_path__ + "img/8.bafc1346.png";